function scannerConfiguration(options) {
  var _options_qualityLevel, _options_recognizesMultipleItems, _options_isHighFrameRateTrackingEnabled, _options_isPinchToZoomEnabled, _options_isGuidanceEnabled, _options_isHighlightingEnabled;
  return {
    recognizedDataTypes: options.recognizedDataTypes.map(function(value) {
      var _value_languages, _value_symbologies;
      return {
        ...value,
        languages: (_value_languages = value.languages) === null || _value_languages === void 0 ? void 0 : _value_languages.slice(),
        symbologies: (_value_symbologies = value.symbologies) === null || _value_symbologies === void 0 ? void 0 : _value_symbologies.slice()
      };
    }),
    qualityLevel: (_options_qualityLevel = options.qualityLevel) !== null && _options_qualityLevel !== void 0 ? _options_qualityLevel : "balanced",
    recognizesMultipleItems: (_options_recognizesMultipleItems = options.recognizesMultipleItems) !== null && _options_recognizesMultipleItems !== void 0 ? _options_recognizesMultipleItems : false,
    isHighFrameRateTrackingEnabled: (_options_isHighFrameRateTrackingEnabled = options.isHighFrameRateTrackingEnabled) !== null && _options_isHighFrameRateTrackingEnabled !== void 0 ? _options_isHighFrameRateTrackingEnabled : true,
    isPinchToZoomEnabled: (_options_isPinchToZoomEnabled = options.isPinchToZoomEnabled) !== null && _options_isPinchToZoomEnabled !== void 0 ? _options_isPinchToZoomEnabled : true,
    isGuidanceEnabled: (_options_isGuidanceEnabled = options.isGuidanceEnabled) !== null && _options_isGuidanceEnabled !== void 0 ? _options_isGuidanceEnabled : true,
    isHighlightingEnabled: (_options_isHighlightingEnabled = options.isHighlightingEnabled) !== null && _options_isHighlightingEnabled !== void 0 ? _options_isHighlightingEnabled : false
  };
}
var RecognizedDataType = {
  text() {
    var languages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], textContentType = arguments.length > 1 ? arguments[1] : void 0;
    return {
      type: "text",
      languages,
      textContentType
    };
  },
  barcode() {
    var symbologies = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return {
      type: "barcode",
      symbologies
    };
  }
};
export {
  RecognizedDataType,
  scannerConfiguration
};
//# sourceMappingURL=configuration.js.map
